@if (!initialized) {
<ft-loading></ft-loading>
}
@if (initialized) {
<div cdkScrollable ftFormColor ftBackgroundImage class="mainContent background-color-holder">
    @if (renderForm) {
    <ft-main-template [params]="params"></ft-main-template>
    }
</div>
}
